var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "orientation-handler",
          rawName: "v-orientation-handler",
          value: {
            layout: _vm.wizardLayout,
            breakPoint: _vm.orientationBreakPoint,
          },
          expression:
            "{ layout: wizardLayout,  breakPoint: orientationBreakPoint }",
        },
      ],
      staticClass: "wizard",
      class: _vm.computedLayout,
    },
    [
      _vm.computedLayout === "horizontal"
        ? _c(
            "div",
            {
              staticClass: "indicator-container indicator-container-horizontal",
            },
            [
              _vm.wizardType === "simple"
                ? _c("simple-horizontal-indicator", {
                    attrs: {
                      steps: _vm.steps,
                      currentStep: _vm.currentStep,
                      completed: _vm.wizardCompleted,
                    },
                    on: { changeCurrentStep: _vm.changeCurrentStep },
                  })
                : _vm._e(),
              _vm.wizardType === "rich"
                ? _c("rich-horizontal-indicator", {
                    attrs: {
                      steps: _vm.steps,
                      currentStep: _vm.currentStep,
                      completed: _vm.wizardCompleted,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.computedLayout === "vertical"
        ? _c(
            "div",
            { staticClass: "indicator-container indicator-container-vertical" },
            [
              _vm.wizardType === "rich"
                ? _c("rich-vertical-indicator", {
                    attrs: {
                      steps: _vm.steps,
                      currentStep: _vm.currentStep,
                      completed: _vm.wizardCompleted,
                    },
                  })
                : _vm._e(),
              _vm.wizardType === "simple"
                ? _c("simple-vertical-indicator", {
                    attrs: {
                      steps: _vm.steps,
                      currentStep: _vm.currentStep,
                      completed: _vm.wizardCompleted,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "wizard-body" },
        [
          _vm._l(_vm.steps, function (step, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isStepShown(step),
                    expression: "isStepShown(step)",
                  },
                ],
                key: index,
                staticClass: "wizard-body-step",
              },
              [_vm._t(step.slot)],
              2
            )
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.wizardCompleted,
                  expression: "wizardCompleted",
                },
              ],
              staticClass: "wizard-body-step",
            },
            [_vm._t(_vm.wizardCompletedSlotName)],
            2
          ),
          !_vm.wizardCompleted
            ? _c("div", { staticClass: "wizard-body-actions" }, [
                _vm.backEnabled
                  ? _c("div", { staticClass: "btn-container" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary wizard-back pull-left",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.goBack()
                            },
                          },
                        },
                        [_vm._v("\n          Back\n        ")]
                      ),
                    ])
                  : _vm._e(),
                !_vm.isLastStep()
                  ? _c("div", { staticClass: "btn-container" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary wizard-next pull-right",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.goNext()
                            },
                          },
                        },
                        [_vm._v("\n          Next\n        ")]
                      ),
                    ])
                  : _vm._e(),
                _vm.currentStep == _vm.steps.length - 1
                  ? _c("div", { staticClass: "btn-container" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary wizard-next pull-right final-step",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.completeWizard()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.lastStepLabel) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }